import MealListContainer from './MealListContainer';
export default MealListContainer;
